// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PJzX","toggle":"styles_toggle__KHSBr","preview":"styles_preview__imWO9"};